
const img1 = require("../assests/GRR-100-2023.png");
const img2 = require("../assests/IFLR1000_2023-24_Top_Tier_Firm.png");

export const award = [img1,  img2, img2, img1,  img2,img1,  img2, img2, img1,  img2,];

export const awards = [
    {
      title: "Top 10 Law Firms in India - 2023",
      image: img1,
      description: "Recognized among the top law firms in India for excellence in litigation, corporate law, and client advocacy.",
    },
    {
      title: "Best Corporate Law Firm - 2022",
      image: img1,
      description: "Awarded for our outstanding services in corporate legal advisory, business structuring, and compliance management.",
    },
    {
      title: "Outstanding Mediation Practice - 2021",
      image: img1,
      description: "Honored for successfully resolving high-profile disputes through mediation and alternative dispute resolution methods.",
    },
    {
      title: "Excellence in Criminal Defense - 2020",
      image: img1,
      description: "Recognized for our top-tier legal representation in criminal law, securing justice for clients in complex cases.",
    },
    {
      title: "Best Taxation & Financial Law Firm - 2019",
      image: img1,
      description: "Awarded for our expertise in taxation law, financial restructuring, and regulatory compliance.",
    },
    {
      title: "Top Intellectual Property Law Firm - 2018",
      image: img1,
      description: "Acknowledged for our excellence in protecting trademarks, copyrights, and intellectual property rights.",
    },
  ];
  